import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import './AccountDeletedPage.css';

const AccountDeletedPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="account-deleted-page">
      <div className="account-deleted-container">
        <div className="account-deleted-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>

        <div className="account-deleted-content">
          <h1 className="account-deleted-title">
            {t('accountDeleted.title')}
          </h1>
          <p className="account-deleted-description">
            {t('accountDeleted.description')}
          </p>
          <p className="account-deleted-gdpr">
            {t('accountDeleted.gdprNotice')}
          </p>
          <button
            type="button"
            className="account-deleted-button"
            onClick={handleGoHome}
          >
            {t('accountDeleted.button')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletedPage;
